/*
Copyright (C) 2022 Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import { Field } from "@src/@types/Field";
import type { SchemaProperties, SchemaDefinitions } from "@src/@types/Schema";
import OptionsSchemaParserBase from "../default/OptionsSchemaPlugin";

// Options of the migrated VM people usually need to set.
const SIMPLE_VIEW_FIELDS = [
  "location",
  "vm_size",
  "network_security_group_id",
  "assign_public_ip",
  "allow_remote_access",
  "remote_access_cidr",
];

export default class OptionsSchemaParser extends OptionsSchemaParserBase {
  override parseSchemaToFields(opts: {
    schema: SchemaProperties;
    schemaDefinitions?: SchemaDefinitions | null | undefined;
    dictionaryKey?: string;
    requiresWindowsImage?: boolean;
  }) {
    const { schemaDefinitions } = opts;
    if (schemaDefinitions?.azure_image?.required) {
      schemaDefinitions.azure_image.required = [];
    }
    const fields: Field[] = super.parseSchemaToFields(opts);
    fields
      .filter(f => SIMPLE_VIEW_FIELDS.includes(f.name))
      .forEach(f => {
        f.simple = true;
      });
    return fields;
  }
}
